declare global {
  interface Window {
    pym: any
  }
}
import functionalFeaturesService from '@/services/embeds/functionalFeatures.service'
import loadScriptInBody from '@/services/loadScriptInBody.service'
import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
/**
 * Post action for the embed pym
 * @param count - The count
 */
const postEmbedPymAction = async (count: number = 0) => {
  if (!window.pym) {
    if (count > 20) {
      useIdeStore().setShareNotFound(true)
      useIdeStore().setShareNotFoundHttpError('Unable to load the Embeds. Please try again later.')
    } else {
      await new Promise((resolve) => setTimeout(resolve, 600))
      postEmbedPymAction(count + 1)
    }
  } else {
    window.pym.Child({ polling: 500 })
    await new Promise((resolve) => setTimeout(resolve, 100))
    const embed = useEmbedConfigureStore().getEmbed
    useIdeStore().setPymKey(embed.id as string)
    useIdeStore().setPymChild(new window.pym.Child())
    functionalFeaturesService.initFunctionalFeatures()
  }
}

/**
 * inject the pym script
 */
const injectPym = () => {
  loadScriptInBody.loadScriptInBody('/assets/jdoodle-pym.min.js')
}
/**
 * eject the pym script
 */
const ejectPym = () => {
  loadScriptInBody.unloadScriptInBody('/assets/jdoodle-pym.min.js')
}
export default { postEmbedPymAction, injectPym, ejectPym }
